import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { TransitionBoxWrapper } from "./TransitionBox.styled";

export const TransitionBox = ({
  isOpen,
  children,
  addStyles,
  transformType = false,
}) => {
  const nodeRef = useRef(null);
  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={isOpen}
      timeout={300}
      classNames={{
        enter: "dropdown-enter",
        enterActive: "dropdown-enter-active",
        exit: "dropdown-exit",
        exitActive: "dropdown-exit-active",
      }}
      unmountOnExit
    >
      <TransitionBoxWrapper
        ref={nodeRef}
        transformType={transformType}
        addStyles={addStyles}
      >
        {children}
      </TransitionBoxWrapper>
    </CSSTransition>
  );
};
